<div class="location-container">
  <!-- <ion-label class="input-label section-label">Location</ion-label> -->
  <!-- Make the whole display area clickable -->
  <div
    class="location-display"
    [class.disabled]="disabled"
    (click)="onMoveClick($event)"
    role="button"
    [attr.aria-label]="
      'Current location: ' + ariaLabelPathString + '. Click to move article.'
    "
    [attr.tabindex]="disabled ? -1 : 0"
  >
    <!-- Loading State -->
    <ng-container *ngIf="isLoadingPath">
      <ion-icon
        name="folder-outline"
        class="location-icon"
        aria-hidden="true"
      ></ion-icon>
      <ion-skeleton-text
        animated
        style="width: 120px; height: 16px"
      ></ion-skeleton-text>
    </ng-container>

    <!-- Loaded State -->
    <ng-container *ngIf="!isLoadingPath">
      <ion-icon
        name="folder-outline"
        class="location-icon"
        aria-hidden="true"
      ></ion-icon>

      <!-- Root Location -->
      <span
        class="path-segment"
        [class.path-root]="collectionPath.length === 0"
      >
        {{ rootLocationName }}
      </span>

      <!-- Path Segments if they exist -->
      <ng-container *ngIf="collectionPath.length > 0">
        <span class="path-separator" aria-hidden="true">/</span>
        <ng-container *ngFor="let segment of collectionPath; let isLast = last">
          <span class="path-segment">{{ segment.name }}</span>
          <span *ngIf="!isLast" class="path-separator" aria-hidden="true"
            >/</span
          >
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
